export default __webpack_public_path__ + "a81b47ddb341fc7a06dce7ea991a72d1.svg";